"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Error = Error;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _Alert = _interopRequireDefault(require("mdi-material-ui/Alert"));
var _OpenInNew = _interopRequireDefault(require("mdi-material-ui/OpenInNew"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    noResultsContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: theme.spacing(4),
      '& h4': {
        color: theme.palette.NEUTRAL700,
        fontWeight: 700,
        lineHeight: theme.typography.pxToRem(24),
        margin: 0,
        marginBottom: theme.spacing(0.5)
      },
      '& p': {
        textAlign: 'center',
        color: theme.palette.NEUTRAL700,
        fontWeight: 400,
        lineHeight: theme.typography.pxToRem(24),
        margin: 0
      }
    },
    erroIcon: {
      color: theme.palette.RED300,
      fontSize: theme.typography.pxToRem(28),
      marginBottom: theme.spacing(1)
    },
    link: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      color: theme.palette.BLUE400,
      fontWeight: 700,
      marginTop: theme.spacing(2)
    },
    openIcon: {
      marginLeft: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(20)
    }
  };
});
function Error() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.noResultsContainer
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    className: classes.erroIcon
  }), /*#__PURE__*/_react.default.createElement("h4", null, "Error retrieving content"), /*#__PURE__*/_react.default.createElement("p", null, "We're working on a fix. Until then, you can try searching Tackle Docs directly to find answers."), /*#__PURE__*/_react.default.createElement("a", {
    className: classes.link,
    href: "https://docs.tackle.io",
    target: "__blank"
  }, "Tackle Docs ", /*#__PURE__*/_react.default.createElement(_OpenInNew.default, {
    className: classes.openIcon
  })));
}